import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toUserMessage } from 'utils/apiErrorHelper';
import { api, getUserId } from '../DefaultService';

export interface IQuarantinedDeviceProps {
  id: number;
  deviceId: number;
  deviceName?: string | null;
  reason?: string | null;
  createdAt: string;
  // null = quarentena indefinida, até remover manualmente.
  quarantinedUntil?: string | null;
  isAutomatic: boolean;
}

const ENDPOINT = '/v1/sports/video-retry-quarantine';
const USER_ID = getUserId();

const getActiveQuarantinesAsync = async (): Promise<IQuarantinedDeviceProps[]> => {
  try {
    const response = await api.get(ENDPOINT);
    return response.data;
  } catch (error) {
    throw new Error(toUserMessage(error));
  }
};

export const useGetActiveQuarantinesQuery = () =>
  useQuery(['sportVideoRetryQuarantine', USER_ID], {
    queryFn: getActiveQuarantinesAsync,
    // Não precisa de poll agressivo — quem gerencia isso já vê o resultado na hora pela própria
    // mutation, esse refetch é só pra manter sincronizado entre abas/usuários.
    refetchInterval: 15000,
  });

export const useQuarantineDeviceMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async ({
      deviceId,
      reason,
      durationMinutes,
    }: {
      deviceId: number;
      reason?: string;
      durationMinutes?: number;
    }) => {
      const { data } = await api.post(`${ENDPOINT}/${deviceId}`, {
        reason,
        durationMinutes,
      });
      return data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['sportVideoRetryQuarantine', USER_ID]);
      },
    },
  );
};

export const useRemoveQuarantineMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async (deviceId: number) => {
      await api.delete(`${ENDPOINT}/${deviceId}`);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['sportVideoRetryQuarantine', USER_ID]);
      },
    },
  );
};
